(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-ravn-filter]');
    if (!button) return;
    const section = button.closest('[data-testid="product-list"]');
    if (!section) return;
    const selected = button.dataset.ravnFilter;
    section.querySelectorAll('[data-ravn-filter]').forEach((option) => {
      option.setAttribute('aria-pressed', String(option === button));
    });
    section.querySelectorAll('[data-ravn-featured-type]').forEach((item) => {
      item.hidden = selected !== 'all' && item.dataset.ravnFeaturedType !== selected;
    });
    const status = section.querySelector('[data-ravn-filter-status]');
    if (status) status.textContent = selected === 'all' ? 'Showing all pieces' : 'Showing ' + button.textContent.trim();
  });

  } catch(e) { console.error(e); }
})();
})();
